<template>
  <div class="cookies" :class="{ 'd-none': $store.state.cookies }">
    <div class="cookies-wrapper">
      <div class="cookie-text">
        <span>{{ getSnippets('Cookies') }}</span>
      </div>
      <button type="button" class="cookie-button" @click="setCookies(true)">
        <span class="line line1"></span>
        <span class="line line2"></span>
      </button>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Cookies',
  mixins: [Default],
  props: [
    'data'
  ]
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.cookies {
  position: fixed;
  z-index: 9999;
  bottom: 0;
  right: 0;
  line-height: 20px;
  color: $black;
  text-shadow: none;
  transition: $transition;

  // Mobile
  @include media-breakpoint-down(sm) {
    width: unset;
    max-width: none;
    margin: 15px;
  }

  .cookies-wrapper {
    position: relative;
    float: right;
    background: $white;
    color: $black;
    min-width: 500px;
    max-width: 500px;
    margin: 25px 15px;
    padding: 15px 20px 20px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

    // Mobile
    @include media-breakpoint-down(sm) {
      width: 100%;
      max-width: unset;
      min-width: unset;
      margin: 0;
    }

    .cookie-text {
      width: 90%;
      font-size: 16px;
      font-weight: 300;
      line-height: 28px;
      border-right: 1px solid $white;
      padding-right: 8px;

      // Mobile
      @include media-breakpoint-down(sm) {
        width: 90%;
        font-size: 14px;
      }

      a {
        color: $black;
      }
    }

    .cookie-button {
      position: absolute;
      background: transparent;
      border-color: transparent;
      right: 20px;
      top: 15px;
      padding: 0;
      width: 30px;
      height: 30px;
      display: inline-block;
      font-size: 46px;
      font-weight: 100;
      line-height: 25px;
      text-decoration: none;
      text-align: center;
      cursor: pointer;

      .line {
        width: 30px;
        height: 1px;
        background: $black;
        display: block;
        position: absolute;
        top: 15px;

        &.line1 {
          transform: rotate(45deg);
        }

        &.line2 {
          transform: rotate(-45deg);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Cookies.vue